import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { removeToken, getToken } from '@/utils/auth' // getToken from cookie

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.path !== '/login') {
    if (getToken()) {
      if (!store.state.token) { // 用户未登录
        store.dispatch('GetAdminInfo').then(res => {
          next()
        }).catch(() => {
          removeToken()
          next({ path: '/login' })
        })
      } else {
        next()
      }
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }
})

router.afterEach(_ => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/router/RouterChangeHandle.js